<div *ngIf="reportByStatusFamily?.length">
    <app-main-table [tableConfig]="tableConfig" class="substate-table"
        (sendInfoToComponent)="openSubstateModal($event)"></app-main-table>
</div>
